import { render, staticRenderFns } from "./Factories.vue?vue&type=template&id=de44a58e&scoped=true&"
import script from "./Factories.vue?vue&type=script&lang=js&"
export * from "./Factories.vue?vue&type=script&lang=js&"
import style0 from "./Factories.vue?vue&type=style&index=0&id=de44a58e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de44a58e",
  null
  
)

export default component.exports